/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserQuestionStatusSendOrderOneOf
 */
export interface UserQuestionStatusSendOrderOneOf {
    /**
     * 
     * @type {string}
     * @memberof UserQuestionStatusSendOrderOneOf
     */
    status: UserQuestionStatusSendOrderOneOfStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UserQuestionStatusSendOrderOneOf
     */
    scheduledSendingDateTime?: string;
}


/**
 * @export
 */
export const UserQuestionStatusSendOrderOneOfStatusEnum = {
    NotSent: 'NOT_SENT'
} as const;
export type UserQuestionStatusSendOrderOneOfStatusEnum = typeof UserQuestionStatusSendOrderOneOfStatusEnum[keyof typeof UserQuestionStatusSendOrderOneOfStatusEnum];


/**
 * Check if a given object implements the UserQuestionStatusSendOrderOneOf interface.
 */
export function instanceOfUserQuestionStatusSendOrderOneOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function UserQuestionStatusSendOrderOneOfFromJSON(json: any): UserQuestionStatusSendOrderOneOf {
    return UserQuestionStatusSendOrderOneOfFromJSONTyped(json, false);
}

export function UserQuestionStatusSendOrderOneOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserQuestionStatusSendOrderOneOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'scheduledSendingDateTime': !exists(json, 'scheduledSendingDateTime') ? undefined : json['scheduledSendingDateTime'],
    };
}

export function UserQuestionStatusSendOrderOneOfToJSON(value?: UserQuestionStatusSendOrderOneOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'scheduledSendingDateTime': value.scheduledSendingDateTime,
    };
}

